// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".widget-timeline li.timeline-items.check:before{font-family:boxicons !important;line-height:1;content:\"\";width:2rem;height:2rem;font-size:1.55rem;left:-3.18rem}.widget-timeline li.timeline-items.check.timeline-icon-success:before{background-color:#05b15b !important}.widget-timeline li.timeline-items.ongoing:before{font-family:boxicons !important;line-height:1;content:\"\";width:2rem;height:2rem;font-size:1.75rem;left:-3.18rem}", ""]);
// Exports
module.exports = exports;
